export const mockapiUrl = 'https://62d2f82581cb1ecafa68a5f5.mockapi.io/';
